export enum AlertStatus {
  INFO, ERROR, WARNING, SUCCESS
}

export enum AlertType {
  TOAST, INLINE
}

export type ToastMessage = {
  message: string
  status: AlertStatus
  alertId: string
}

export type AlertTypeInfo = {
  alertClass: string
  icon: string
  iconColorClass: string
}
